import {
    formatDeadlineDay,
    formatReleaseMoment,
} from '@/shared/utils/deadline';

// The program's own application dates, each falling back to the term's, the
// same rule the server applies. Coordinators browse any term here, and the
// server's per-caller verdict comes only with the current one.
export function programApplicationDates(term, programType) {
    const pw = term?.programWindows?.[programType];
    return {
        open: pw?.applicationOpenDate || term?.applicationOpenDate || null,
        close: pw?.applicationCloseDate || term?.applicationCloseDate || null,
    };
}

// A date-only deadline reads as the day entered, a release moment as its
// Mountain time day
export function formatDate(dateString) {
    return dateString ? formatDeadlineDay(dateString) : 'Not set';
}

// What a decisions release date means for faculty, in words.
export function releaseSentence(date) {
    return date
        ? `Faculty see decisions and get the email on ${formatReleaseMoment(date)}.`
        : 'No date set: faculty see each decision as soon as it is recorded.';
}

// The form holds a bare YYYY-MM-DD, stored as midnight UTC like the server.
export const formDateToStored = (value) =>
    value ? `${value}T00:00:00.000Z` : '';
